var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionLocationMapNavigationPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.55,
    height: 31.399,
    viewBox: "0 0 31.55 31.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.439,
    cy: 0.423,
    r: 0.831,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee0ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.769,
    y1: 0.137,
    x2: 0.129,
    y2: 0.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.782,
    y1: 0.657,
    x2: 0.238,
    y2: 0.184,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d74b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#ee595d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3961984_direction_location_map_navigation_pin_icon",
    "data-name": "3961984_direction_location_map_navigation_pin_icon",
    transform: "translate(-32.268 -30.323)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(32.817 30.323)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5185",
    "data-name": "Rectangle 5185",
    width: 1.882,
    height: 4.243,
    transform: "translate(43.303 49.572) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18602",
    "data-name": "Path 18602",
    d: "M32.826,238.785c-.006.169-.009.339-.009.51,0,.1,0,.2,0,.294l3.049,3.049a5.278,5.278,0,0,0,.463-1.531l-2.914-2.914Z",
    transform: "translate(0 -193.239)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5186",
    "data-name": "Rectangle 5186",
    width: 1.882,
    height: 4.738,
    transform: "translate(46.51 52.78) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5187",
    "data-name": "Rectangle 5187",
    width: 6.701,
    height: 4.738,
    transform: "translate(48.048 51.242) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5188",
    "data-name": "Rectangle 5188",
    width: 3.194,
    height: 2.275,
    transform: "translate(54.735 48.038) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5189",
    "data-name": "Rectangle 5189",
    width: 6.701,
    height: 3.402,
    transform: "translate(42.228 45.422) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5190",
    "data-name": "Rectangle 5190",
    width: 2.067,
    height: 4.738,
    transform: "translate(44.085 55.205) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5191",
    "data-name": "Rectangle 5191",
    width: 2.067,
    height: 4.243,
    transform: "translate(40.877 51.998) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5192",
    "data-name": "Rectangle 5192",
    width: 1.422,
    height: 3.402,
    transform: "translate(47.173 40.477) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5193",
    "data-name": "Rectangle 5193",
    width: 1.479,
    height: 3.402,
    transform: "translate(48.386 39.264) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5194",
    "data-name": "Rectangle 5194",
    width: 2.377,
    height: 4.243,
    transform: "translate(52.252 40.624) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18603",
    "data-name": "Path 18603",
    d: "M46.116,213.862l-1.455,1.455,2.746,2.746A6.707,6.707,0,0,0,46.116,213.862Z",
    transform: "translate(-11.035 -170.57)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18604",
    "data-name": "Path 18604",
    d: "M100.142,250.356l1.263-1.263-1.354-1.354A6.625,6.625,0,0,1,100.142,250.356Z",
    transform: "translate(-62.642 -202.134)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5195",
    "data-name": "Rectangle 5195",
    width: 2.067,
    height: 3.402,
    transform: "translate(38.264 49.385) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5196",
    "data-name": "Rectangle 5196",
    width: 1.882,
    height: 5.198,
    transform: "translate(36.051 42.321) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5197",
    "data-name": "Rectangle 5197",
    width: 1.882,
    height: 3.402,
    transform: "translate(40.69 46.96) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5198",
    "data-name": "Rectangle 5198",
    width: 2.377,
    height: 3.402,
    transform: "translate(49.639 38.011) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18605",
    "data-name": "Path 18605",
    d: "M107.434,107.748l-2.091,2.091,3.585,3.585-.207.207-3.585-3.585-2.44,2.44,3.675,3.675,4.738-4.738Z",
    transform: "translate(-65.107 -71.703)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5199",
    "data-name": "Rectangle 5199",
    width: 3.194,
    height: 5.198,
    transform: "translate(42.534 35.838) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18606",
    "data-name": "Path 18606",
    d: "M33.312,230.633q-.035.335-.055.674l.365-.365Z",
    transform: "translate(-0.41 -186.196)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18607",
    "data-name": "Path 18607",
    d: "M260.978,431.535l1.675,1.675a15.189,15.189,0,0,0,2.409-.515l-2.621-2.621Z",
    transform: "translate(-212.579 -372.016)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5200",
    "data-name": "Rectangle 5200",
    width: 1.422,
    height: 4.243,
    transform: "translate(49.786 43.089) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5201",
    "data-name": "Rectangle 5201",
    width: 3.194,
    height: 2.17,
    transform: "translate(52.993 46.297) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5202",
    "data-name": "Rectangle 5202",
    width: 1.479,
    height: 4.243,
    transform: "translate(50.999 41.877) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5203",
    "data-name": "Rectangle 5203",
    width: 6.701,
    height: 4.243,
    transform: "translate(44.841 48.034) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5204",
    "data-name": "Rectangle 5204",
    width: 2.377,
    height: 2.275,
    transform: "translate(57.2 45.573) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5205",
    "data-name": "Rectangle 5205",
    width: 2.377,
    height: 5.198,
    transform: "translate(45 33.372) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5206",
    "data-name": "Rectangle 5206",
    width: 2.377,
    height: 2.17,
    transform: "translate(55.459 43.831) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10153",
    "data-name": "Group 10153",
    transform: "translate(32.821 31.484)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18608",
    "data-name": "Path 18608",
    d: "M95.552,307.443l-.207-.207L93.883,308.7l-3-3,1.462-1.462-.207-.207-1.462,1.462-2.406-2.406-.207.207,2.406,2.406-3.981,3.981q.1.111.193.221l3.995-3.995,3,3-3.752,3.752c.085.054.169.107.255.159l3.7-3.7,3.35,3.35.207-.207-3.35-3.35Z",
    transform: "translate(-82.826 -285.184)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18609",
    "data-name": "Path 18609",
    d: "M35.21,210.938l-.035-.049-.165-.165-1.462,1.462-.473-.473q-.024.185-.044.371l.309.309-.365.365q-.013.217-.021.435l.592-.592,2.914,2.914q.027-.189.039-.375l-2.746-2.746Z",
    transform: "translate(-32.95 -199.131)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18610",
    "data-name": "Path 18610",
    d: "M32.887,259.065l2.9,2.9q.074-.137.14-.275l-3.049-3.049Q32.877,258.852,32.887,259.065Z",
    transform: "translate(-32.873 -243.771)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18611",
    "data-name": "Path 18611",
    d: "M257.946,451.686l1.511,1.511q.186-.02.371-.044l-1.675-1.675Z",
    transform: "translate(-242.575 -423.444)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5207",
    "data-name": "Rectangle 5207",
    width: 0.293,
    height: 4.965,
    transform: "translate(19.334 24.279) rotate(-45)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18612",
    "data-name": "Path 18612",
    d: "M425.759,171.053l2.453-2.453c-.039-.1-.079-.2-.12-.294l-2.54,2.54Z",
    transform: "translate(-398.735 -159.609)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18613",
    "data-name": "Path 18613",
    d: "M388.392,321.239l3.7,3.7c.055-.083.11-.166.164-.25l-3.652-3.652Z",
    transform: "translate(-364.112 -301.905)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18614",
    "data-name": "Path 18614",
    d: "M184.168,145.91l.207-.207-1.609-1.609,1.681-1.681-.207-.207-1.681,1.681-1.534-1.534,1.681-1.681-.207-.207-1.681,1.681-3-3,1.681-1.681-.207-.207-1.681,1.681-2.406-2.406-.207.207,2.406,2.406-1.046,1.046-2.406-2.406-.207.207,2.406,2.406-1.006,1.006L172.738,139l-.207.207,2.406,2.406-4.738,4.738-2.406-2.406-.207.207,2.406,2.406-1.331,1.331.207.207,1.331-1.331,3,3-1.331,1.331.207.207,1.331-1.331,3.35,3.35.207-.207-3.35-3.35,4.738-4.738,3.35,3.35.207-.207L180.3,146.56l2.259-2.259Zm-6.558-6.558,3,3-1.046,1.046-3-3Zm-4.2,10.2-3-3,4.738-4.738,3,3Zm1.945-7.946,1.006-1.006,3,3-1.006,1.006Zm4.742,4.742-1.534-1.534,2.259-2.259,1.534,1.534Z",
    transform: "translate(-158.386 -130.005)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18615",
    "data-name": "Path 18615",
    d: "M63.486,51.594l.207.207,1.331-1.331L68.7,54.145l.207-.207-3.675-3.675,2.44-2.44,3.585,3.585.207-.207-3.585-3.585,2.091-2.091L73.645,49.2l.207-.207-3.675-3.675,2.259-2.259,3.675,3.675.207-.207-3.675-3.675,1.681-1.681-.207-.207-1.681,1.681-1.582-1.582c-.1.035-.2.071-.307.107l1.681,1.681-2.259,2.259-2.45-2.45c-.084.054-.167.109-.25.164l2.493,2.493-4.738,4.738-2.385-2.385c-.052.086-.1.173-.154.26l2.332,2.332Z",
    transform: "translate(-60.463 -40.964)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5208",
    "data-name": "Rectangle 5208",
    width: 0.293,
    height: 3.904,
    transform: "translate(26.745 16.868) rotate(-45)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18616",
    "data-name": "Path 18616",
    d: "M356.624,84.651q-.11-.1-.221-.193l-3.318,3.318.207.207Z",
    transform: "translate(-331.217 -81.488)",
    fill: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18617",
    "data-name": "Path 18617",
    d: "M400.261,138.075l3.041-3.041c-.052-.086-.105-.171-.159-.255l-3.089,3.089Z",
    transform: "translate(-374.978 -128.372)",
    fill: "#f0f1f2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5209",
    "data-name": "Rectangle 5209",
    width: 0.293,
    height: 1.363,
    transform: "translate(46.002 39.72) rotate(-45)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5210",
    "data-name": "Rectangle 5210",
    width: 0.293,
    height: 0.931,
    transform: "translate(47.52 38.812) rotate(-45)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18618",
    "data-name": "Path 18618",
    d: "M71.206,45.564l.867-.867a15.249,15.249,0,0,0-.249-1.678L70.243,44.6,61.072,35.43l2.853-2.853q-.642-.335-1.318-.609l-2.5,2.5L56.5,30.857l-.137,0q-.218.007-.435.021-.611.037-1.208.122l4.425,4.425L55,39.576l.963.963,4.147-4.147,9.171,9.171L58.65,56.194l-9.171-9.171,6.276-6.276-.963-.963-6.276,6.276-5.76-5.76q-.287.694-.505,1.422l1.42,1.42s.188.2.2.214a6.707,6.707,0,0,1,1.291,4.2q-.013.186-.039.375a5.276,5.276,0,0,1-.463,1.531q-.065.137-.14.275a6.372,6.372,0,0,1-.655.975l-1.143,1.143q.274.675.609,1.318l5.185-5.185,9.171,9.171-3.914,3.914a15.252,15.252,0,0,0,1.678.249l3.2-3.2,2.621,2.621q.727-.218,1.422-.505l-3.079-3.079,1.331-1.331,9.3-9.3,1.745,1.745a15.371,15.371,0,0,0,.147-1.78ZM46.289,48.286a6.625,6.625,0,0,0-.091-2.617l1.354,1.354Z",
    transform: "translate(-8.789 -0.063)",
    fill: "#e2e2e2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10155",
    "data-name": "Group 10155",
    transform: "translate(42.237 36.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18619",
    "data-name": "Path 18619",
    d: "M228.979,123.048a6.669,6.669,0,0,0-5.4-9.359,6.42,6.42,0,0,0-5.624,2.187,6.678,6.678,0,0,0-.427,8.337,6.368,6.368,0,0,1,1.2,4.448l0,.016a.447.447,0,0,0,.791.339h0a4.83,4.83,0,0,1,3.705-2.052A6.647,6.647,0,0,0,228.979,123.048Z",
    transform: "translate(-213.159 -113.642)",
    opacity: 0.3,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10154",
    "data-name": "Group 10154",
    transform: "translate(0 0.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18620",
    "data-name": "Path 18620",
    d: "M182.675,134.13a5.981,5.981,0,0,0-7.861-5.669,5.758,5.758,0,0,0-3.8,3.857,5.989,5.989,0,0,0,2.717,6.976,5.711,5.711,0,0,1,2.614,3.2l0,.013a.4.4,0,0,0,.771-.013h0a4.332,4.332,0,0,1,2.276-3.041A5.962,5.962,0,0,0,182.675,134.13Z",
    transform: "translate(-170.751 -128.168)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 1.895,
    cy: 1.895,
    r: 1.895,
    transform: "translate(4.067 4.067)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionLocationMapNavigationPinIcon);
export default __webpack_public_path__ + "static/media/direction_location_map_navigation_pin_icon.dcea3b4dd76a2fead92b323df547398e.svg";
export { ForwardRef as ReactComponent };